export default __webpack_public_path__ + "static/media/flowers-2x.8a838b6d.png";